import { EventQueueRowData, UnitQueueRowData } from '../../../socket/stream-types';
import { TimeCell } from '../../../queues/components/cells/common/time-cell';
import { observer } from 'mobx-react-lite';
import { getEventQueueRowData } from '../../../queues/utils/get-event-queue-row-data';

export const TimeDispatchedCell = observer(function TimeDispatchedCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    return <TimeCell dateStr={getEventQueueRowData(data)?.timeDispatched} />;
});
